import { FC } from 'react';
import { CustomSearchInput, getCssVarValue } from '@mybonum/ui';
import { Flex } from 'antd';

import { TPatientType } from '../../types';

import { ColumnsConfigurator } from '@/widgets/columns-configurator';

export const PatientsFilter: FC = () => {
    return (
        <Flex gap={getCssVarValue('spacing-sm', true)} wrap="wrap">
            <CustomSearchInput style={{ maxWidth: '450px' }} />
            <ColumnsConfigurator<TPatientType> />
        </Flex>
    );
};
